import { Filters } from '../../utils/enums';
import ActiveFilterBar from './ActiveFilterBar';
import CoreFilterBar, { type CoreFilterBarProps } from './CoreFilterBar';

interface FilterBarProps extends CoreFilterBarProps {
  eventPrefix: string;
  supportedFilters?: Filters[];
  withActiveFilters?: boolean;
  withIntroTagsFilter?: boolean;
}

const FilterBar: React.VFC<FilterBarProps> = ({
  eventPrefix,
  supportedFilters = [],
  withActiveFilters = true,
  withAddFilterButton = true,
  withDateFilter = true,
  withAgeFilter = false,
  withIntroTagsFilter = false,
  withSearchInput = false,
  withCustomFilter = false,
  withCustomFilterLast = false,
  withOnlyMarketCompetitors = false,
  networkFilter,
  adSetFilter,
  assetTypeFilter,
  buyingStrategyFilter,
  agencyFilter,
  promotedObjectFilter,
  kpiFilter,
  campaignFilter,
  campaignTypeFilter,
  monthFilter,
  customFilter,
  marketAppsFilter,
  publisherFilter,
  countryFilter,
  customMarketTagsFilter,
  customTagsFilter,
  dateFilter,
  onSearchTermChangeEnd,
  onlyMarketCompetitors,
  page,
  disabledDatePicker,
}) => (
  <div data-test="filter-bar">
    <CoreFilterBar
      withAddFilterButton={withAddFilterButton}
      withDateFilter={withDateFilter}
      withAgeFilter={withAgeFilter}
      withSearchInput={withSearchInput}
      withCustomFilter={withCustomFilter}
      withCustomFilterLast={withCustomFilterLast}
      withIntroTagsFilter={withIntroTagsFilter}
      withOnlyMarketCompetitors={withOnlyMarketCompetitors}
      networkFilter={networkFilter}
      adSetFilter={adSetFilter}
      buyingStrategyFilter={buyingStrategyFilter}
      assetTypeFilter={assetTypeFilter}
      agencyFilter={agencyFilter}
      promotedObjectFilter={promotedObjectFilter}
      kpiFilter={kpiFilter}
      campaignFilter={campaignFilter}
      campaignTypeFilter={campaignTypeFilter}
      monthFilter={monthFilter}
      customFilter={customFilter}
      marketAppsFilter={marketAppsFilter}
      publisherFilter={publisherFilter}
      countryFilter={countryFilter}
      customMarketTagsFilter={customMarketTagsFilter}
      customTagsFilter={customTagsFilter}
      dateFilter={dateFilter}
      onSearchTermChangeEnd={onSearchTermChangeEnd}
      onlyMarketCompetitors={onlyMarketCompetitors}
      page={page}
      disabledDatePicker={disabledDatePicker}
    />
    {withActiveFilters && <ActiveFilterBar supportedFilters={supportedFilters} eventPrefix={eventPrefix} />}
  </div>
);

export default FilterBar;
